<template>
  <div>
    <notifications />
    <RouterView/>
  </div>
</template>

